import locale from 'scripts/utils/locale';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc)
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime)

dayjs.updateLocale('en', {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'seconds',
        m: '1 minute',
        mm: '%d minutes',
        h: '1 hour',
        hh: '%d hours',
        d: '1 day',
        dd: '%d days',
        M: '1 month',
        MM: '%d months',
        y: '1 year',
        yy: '%d years'
    }
});

export default {
    getTimezone() {
        return dayjs.tz(dayjs.tz.guess())
    },

    parseDate: function (date) {
        date = +date ? +date : date;
        return dayjs(date).locale(locale.getLocale());
    },

    parseUTCDate: function (date) {
        return dayjs.utc(date).locale(locale.getLocale());
    },

    // returns moment Date object from moment timestamp
    parseTimestamp: function (timestamp, isMilliseconds) {
        return (isMilliseconds ? dayjs(timestamp) : dayjs.unix(timestamp)).locale(locale.getLocale());
    },

    // returns current date
    valueOf: function (date) {
        return dayjs(date).valueOf();
    },

    // returns duration in seconds formatted as hh:mm:ss
    duration: function (seconds) {
        var secondsInMinute = 60;
        var pad = (num) => {
            return num < 10 ? ('0' + num).slice(-2) : num;
        };
        var minutes = Math.floor(seconds / secondsInMinute);
        seconds = seconds % secondsInMinute;
        var hours = Math.floor(minutes / secondsInMinute);
        minutes = minutes % secondsInMinute;
        var result = '';
        if (hours) {
            result += pad(hours) + ':';
        }
        result += (result ? pad(minutes) : minutes) + ':';
        result += pad(seconds);
        return result;
    },

    // returns time ago
    timeAgo: function (date) {
        return dayjs(date).fromNow();
    },

    formatDate: function (date, format) {
        date = _.isFunction(date) ? date() : date;
        format = _.isFunction(format) ? format() : format;
        return this.toLocal(date).format(format || 'DD MMM YYYY');
    },

    toDate: function (date) {
        return dayjs(date).toDate();
    },

    isInProgress: function (start, end) {
        var now = new Date().valueOf();
        var startDate = this.valueOf(start);
        var endDate = this.valueOf(end);
        return startDate < now && now < endDate;
    },

    toLocal: function (date) {
        return dayjs(date).local();
    },

    parseDateObj: function (obj) {
        if (obj.timezone) {
            return obj.utc + obj.timezone;
        } else {
            return obj.utc + 'Z';
        }
    },

    timeLeft: function (date) {
        var now = dayjs(new Date()).valueOf();
        var start = dayjs(date);
        var duration = dayjs.duration(start - now, 'milliseconds');
        return {
            days: duration.days(),
            hours: duration.hours(),
            minutes: duration.minutes(),
            total: now - start
        };
    },

    getFutureYearsFromNow: function (yearsFromNow) {
        var currentYear = new Date().getFullYear();
        var result = [currentYear];
        if (yearsFromNow) {
            for (var i = 0; i < yearsFromNow; i += 1) {
                currentYear += 1;
                result.push(currentYear);
            }
        }
        return result;
    },

    getPastYearsRange: function (startYear, stopYear) {
        var currentYear = new Date().getFullYear();
        var result = [];
        if (startYear && stopYear) {
            for (var i = currentYear - startYear, last = currentYear - stopYear; i <= last; i += 1) {
                result.push(i);
            }
        }
        return result;
    },

    getMonthsNames: function (startMonth, stopMonth) {
        var monthsNames = dayjs.months();
        var result = [];
        startMonth = startMonth || 0;
        stopMonth = stopMonth || 11;
        for (var i = startMonth; i <= stopMonth; i += 1) {
            result.push({
                number: i + 1,
                name: monthsNames[i]
            });
        }
        return result;
    },

    getMonthsNumbers: function () {
        var result = [];
        for (var i = 1, len = 12; i <= len; i += 1) {
            result.push(i);
        }
        return result;
    },

    getMonthDates: function (year, month, stopDate) {
        var result = [];
        if (year) {
            month = month || 0;
            let startDate = dayjs([year, month, 0, 0, 0, 0]).toDate();
            let monthEndDay = stopDate || dayjs(startDate).endOf('month').date();
            for (var i = 1; i <= monthEndDay; i += 1) {
                result.push(i);
            }
        }
        return result;
    },

    timeDiff: function (startDate, endDate, period) {
        startDate = dayjs(startDate);
        endDate = dayjs(endDate);
        if (period) {
            return endDate.diff(startDate, period);
        } else {
            return endDate.diff(startDate);
        }
    },

    getTimeDiffFromNightInStr: function (timeStr) {
        let isDate = /^\s*[0-9]{1,2}:[0-9]{1,2}\s*[ap]m/i.test(timeStr);

        if (isDate) {
            return dayjs(timeStr, 'HH:mma').diff(dayjs('00:00AM', 'HH:mma'));
        }
    },

    isToday: function (date) {
        var now = dayjs();
        date = dayjs(date);
        return date.isSame(now, 'day');
    },

    getCurrentYear: function () {
        return dayjs().year();
    }
};

